import type { IOffer } from "@domain/Marketplace";
import type { ConditionType } from "@domain/Vehicle";
import type { IConditionConfiguration, IConditionConfigurationDto } from "./IConditionConfiguration";
import { CallToActionType } from "@domain/General/Enums/CallToActionType";

export class ConditionConfiguration implements IConditionConfiguration
{

    conditionType: ConditionType;
    name: string;
    ordinal: number;
    categoryId?: string;
    offerId?: string;
    hasOriginatorCapability: boolean;
    isDisabled: boolean;
    canUserDisable: boolean;
    offer: IOffer | null = null; // Set by the AppConfiguration's initialise() method
    callToAction?: string | undefined;
    callToActionType: CallToActionType;

    constructor( model: IConditionConfigurationDto )
    {
        this.conditionType = model.conditionType; // The condition type
        this.name = model.name; // The name of the condition
        this.ordinal = model.ordinal ?? 0; // The sort ordinal
        this.categoryId = model.categoryId; // The optionally mapped category id
        this.offerId = model.offerId; // The optionally mapped offer ID
        this.hasOriginatorCapability = model.hasOriginatorCapability; // True if the originator provides offers in this category
        this.isDisabled = model.isDisabled; // True if the condition has been disabled in this app configuration
        this.canUserDisable = model.canUserDisable; // True if the user is allowed to disable the condition
        this.callToActionType = model.callToActionType;
        this.callToAction = model.callToAction;
    }

    get hasOffer() { return this.offer != null }
    get hasCategory() { return this.categoryId != undefined }
    get isNotLinkedToMarketplace() { return this.hasCategory == false && this.hasOffer == false }

    /**
     * Creates a state for a configuration that was not found
     * @param type
     * @returns
     */
    public static NOT_FOUND = ( type: ConditionType ) =>
    {
        return new ConditionConfiguration( {
            conditionType: type,
            name: 'Not Found',
            ordinal: 0,
            hasOriginatorCapability: false,
            isDisabled: true,
            canUserDisable: false,
            callToActionType: CallToActionType.NotSet,
            callToAction: undefined,
        } );
    };

}
